import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';

export const HorizontalRule = ({ color = '#000', marginHorizontal }) => {
    return (
        <View
            style={{
                borderBottomColor: color,
                borderBottomWidth: StyleSheet.hairlineWidth,
                marginHorizontal: marginHorizontal
            }}
        />
    );
};

HorizontalRule.propTypes = {
    color: PropTypes.string,
    marginHorizontal: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
